import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { BLACK } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    ".Mui-selected": {
      border: "2px solid blue",
    },
  },
  boxGlobal: {
    display: "flex",
    justifyContent: "space-between",
    width: "66rem",
  },
  boxTabs: {
    padding: "10px",
    position: "fixed",
  },
  boxInterception: {
    width: "29.2rem !important",
    height: "10px",
  },
  indicator: {
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
  stepMenu: {
    "&:hover": {
      background: "#E8E8E8",
    },
    "&.Mui-selected": {
      border: "2px solid #2813AD",
      background: "#EDEDED",
    },

    "&.Mui-disabled": { border: "none" },

    justifyContent: "left !important",
    padding: "0rem 1rem 0rem 1rem  !important",
    borderRadius: "10px !important",
    margin: "0rem 4rem !important",
    width: "19.68rem",
    color: "black !important",
  },
  iconTimeline: {
    background: "#2813AD",
    height: "24px",
    width: "24px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white !important",
    fontWeight: "700 !important",
    fontSize: "1rem !important,",
    lineHeight: "2rem !important",
    textAlign: "center",
  },
  iconTimelineDisabled: {
    background: "#FFF",
    color: `${BLACK} !important`,
  },
}));
